import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Umbrella = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 4C9.387 4 4 9.387 4 16C4 17.1 4.9 18 6 18H14V24C14 26.2 15.8 28 18 28C20.2 28 22 26.2 22 24V23C22 22.45 21.55 22 21 22C20.45 22 20 22.45 20 23V24C20 25.1 19.1 26 18 26C16.9 26 16 25.1 16 24V18H26C27.1 18 28 17.1 28 16C28 9.387 22.613 4 16 4ZM6 16C6 11.875 8.5 8.338 12.075 6.8C11.9 7.113 11.725 7.438 11.563 7.8C10.551 10.013 10 12.925 10 16H6V16ZM12 16C12 13.2 12.488 10.588 13.375 8.637C14.125 6.987 15.113 5.999 16 5.999C16.887 5.999 17.875 6.986 18.625 8.637C19.512 10.587 20 13.2 20 16H12ZM22 16C22 12.925 21.45 10.012 20.45 7.8C20.287 7.438 20.113 7.112 19.938 6.8C23.501 8.337 26.001 11.875 26.001 16H22.001H22Z" />
	</svg>
);

export default Umbrella;
